export default "__VITE_PUBLIC_ASSET__3d71b945__"